/**
 * app.js
 * @author      Marc-André Appel <marcandre.appel@gmail.com>
 * @copyright   2015 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        http://www.sudimage.com
 /* eslint-env jquery */
/* eslint no-var:0 */
/* global HEADER_IMAGE_SLIDER, Scrolling, setupDrawers */

// @codekit-prepend "../bower_components/slick-carousel/slick/slick.js";
// @codekit-prepend "../bower_components/jquery.scrolling/jquery.scrolling.js";
// @codekit-prepend "../bower_components/drawerfy/dist/drawerfy.js";
// @codekit-prepend "./src/clamp.js";
// @codekit-prepend "./src/slick.js";

const defaultHeaderHeight = 0.24;
const backstretchFade = 1000;
const $window = $(window);

const WebFontConfig = {
    google: {
        families: [
            'Open+Sans:400,800,600,700,300:latin',
            'Federo:400,300,300italic,400italic,500,500italic,700,700italic:latin',
            'Ubuntu:400,300,300italic,400italic,500,500italic,700,700italic:latin'
        ]
    }
};
(function () {
    let wf = document.createElement('script');
    let s;
    wf.src = (document.location.protocol === 'https:' ? 'https' : 'http') +
        '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
})(WebFontConfig);

$(document).ready(function () {
    if ($window.width() >= 768) {
        const ccmPage = $('.ccm-page');
        const body = $('body');
        const $header = $('header');
        const $backstretch = $('.backstretch-container');

        if (typeof HEADER_IMAGE_SLIDER !== 'undefined') {
            if ( ! CCM_EDIT_MODE) {
                if (ccmPage.hasClass('page-type-intro') || ccmPage.hasClass('page-template-intro')) {
                    let utilityBarHeight = $('.utility-bar').outerHeight() || 0;
                    // let footerHeight = $('footer').outerHeight() || 0;
                    let headerHeight = $('.sub-header', $header).outerHeight() + $('.sup-header', $header).outerHeight();
                    let contentHeight = $('main').outerHeight() || 0;
                    let backstretchHeight = Math.floor(
                        $window.height() * .5
                    );
                    $backstretch.css({
                        height: backstretchHeight
                    });

                } else {
                    $backstretch.css({
                        height: Math.floor($(window).height() * defaultHeaderHeight)
                    });
                }
                $backstretch.backstretch(HEADER_IMAGE_SLIDER, {
                    fade: backstretchFade
                });
            }
        }

        $('.navbar-nav a.dropdown-toggle').on('click', function (e) {
            let ul = $(this).parent().parent();
            let li;
            if (!ul.hasClass('nav')) {
                e.preventDefault();
                $('li', ul).each(function () {
                    if ($(this).hasClass('open')) {
                        $(this).removeClass('open');
                    }
                });
                li = $(this).parent();
                if (!li.hasClass('open')) {
                    li.addClass('open');
                } else {
                    li.removeClass('open');
                }
                $(this).next().css({
                    'marginTop': '-' + li.outerHeight() + 'px',
                    'left': li.width() + 'px'
                });
                return false;
            }
        });
        /**
         * Repositionnement des soumenus en fonction de leur emplacement dans la page
         */
        $('li', '.navbar-nav').each(function () {
            let $this = $(this);
            if ($this.offset().left < Math.floor($(window).width() / 2)) {
                $this.children('ul').css({
                    left: 0,
                    right: 'auto'
                });
            }
        });
        /**
         * Positionnement de la navigation dans la barre de gauche
         */
        const mainNav = $('.navbar-dynamic-navigation');
        const mainNavPos = mainNav.position().top;
        const mainNavHeight = mainNav.outerHeight();
        $('.sidebar-nav').css({
            marginTop: mainNavPos + mainNavHeight
        });
    }
});

// @codekit-append "./src/font-size-selector.js";
// @codekit-append "./src/static-side-navigation.js";
// @codekit-append "./src/sudimage-drawerfy.js";